import http from '../../utils/fetch';
import updownfile from '../../utils/updownfile';
export default {
    bomMain:'/api/swyl/v1/bom/bomMain',
    bomMainDetail:'/api/swyl/v1/bom/bomMainDetail',
    packageScene: '/api/swyl/v1/bom/bomPackageScene',


    searchBom(q){
        return http({
            url: this.bomMain + '/selectPage',
            method: 'post',
            params: q
        });
    },
    //查询全部套餐
    loadMeal(query){
        return http({
            url: this.bomMain + '/selectAllList',
            method: 'post',
            params: query
        });
    },
    selectByCode(query) {
        return http({
            url: this.bomMain + '/selectByCode',
            method: 'post',
            params: query
        });
    },

    save(query){
        return http.post(this.bomMain + '/insert', query);
    },
    zancun(query){
        return http.post(this.bomMain + '/zancun', query);
    },
    updateById(query) {
        return http.post(this.bomMain + '/updateById', query);
    },
    toDelete(v) {
        return http.post(this.bomMain + '/deleteById?id=' + v);
    },
    selectById(v) {
        return http.post(this.bomMain + '/selectById?id=' + v);
    },
    selectByProdcode(v) {
        return http.post(this.bomMain + '/selectByProdcode', v);
     },
    selectByIdList(v) {
        return http.post(this.bomMain + '/selectByIdList', v);
    },

    shenpiBom(q){
        return http.post(this.bomMain + '/shenpiBom',q);
    },

    //新建场景信息
    createScene(q){
        return http({
            url: this.packageScene + '/insertSceneInfo',
            method: 'post',
            params: q
        });
    },
    //查询场景信息
    selectScenePage(q){
        return http({
            url: this.packageScene + '/selectPage',
            method: 'post',
            params: q
        });
    },
    //禁用/启用套餐场景
    banScene(data){
        return http({
            url: this.packageScene + '/banSceneData',
            method: 'post',
            params: data
        });
    },
    //获取场景信息
    getSceneList(data){
        return http({
            url: this.packageScene + '/getSceneList',
            method: 'post',
            params: data
        })
    },
    //获取场景信息
    getPackageByLq(data){
        return http({
            url: this.packageScene + '/getPackageByLq',
            method: 'post',
            params: data
        })
    },
    //获取所有场景信息
    getAllSceneList(){
        return http({
            url: this.packageScene + '/getAllSceneList',
            method: 'post'
        })
    },

    //产局场景编码和链群编码获取套餐信息
    getPackageList(data){
        return http({
            url: this.bomMain + '/selectBySceneAndLq',
            method: 'post',
            params: data
        })
    },
    //获取场景信息
    getPackageDetail(data){
        return http({
            url: this.bomMainDetail + '/selectList',
            method: 'post',
            params: data
        })
    },
    // 获取特价信息
    getTejiaList(query){
        return http({
            url: this.bomMain + '/getTejiaList',
            method: 'post',
            params: query
        });
    },
    // 获取税分类编码
    getTaxcodeList(data){
        return http({
            url: '/api/swyl/v1/productlevel/productLevel/selectTaxcode',
            method: 'post',
            params: data
        });
    },
    //套餐销售样表分页查询
    selectSalesPage(data){
        return http({
            url: '/api/swyl/v1/bom/bomSales/selectPage',
            method: 'post',
            params: data
        });
    },
    //套餐销售样表分页查询
    checkFin(data){
        return http({
            url: '/api/swyl/v1/bom/bomMain/checkFinance',
            method: 'post',
            params: data
        });
    },
    // 根据经销商获取套餐信息
    selectPackageList(query){
        return http({
            url: this.bomMain + '/selectPackageList',
            method: 'post',
            params: query
        });
    },
}
